<template>
	<div id="desktop">
		<img :src="`/images/home/v6/brain.svg`" alt="brain" />
	</div>

	<div id="mobile">
		<img :src="`/images/home/v6/brain-1.svg`" alt="brain" />
		<img :src="`/images/home/v6/brain-2.svg`" alt="brain" />
		<img :src="`/images/home/v6/brain-3.svg`" alt="brain" />
	</div>
</template>

<script>
	import { computed, defineComponent, ref } from 'vue'
	export default defineComponent({
		name: 'OurMissionBrainV6',
		props: {
			view: {
				type: String,
				default: () => 'full',
			},
		},
		setup(props) {
			const brainRef = ref(null)

			const currentView = computed(() => props.view)

			const baseClass = computed(() => `our-mission-brain-view-mode--${props.view}`)

			const viewBox = computed(() => {
				if (props.view === 'center') {
					return '375 0 490 855'
				} else if (props.view === 'left') {
					return '0 0 565 855'
				} else if (props.view === 'right') {
					return '650 0 610 855'
				} else {
					return '0 0 1241 855'
				}
			})
			const viewPortSize = computed(() => {
				if (props.view === 'center') {
					return { width: 490, height: '100%' }
				} else if (props.view === 'left') {
					return { width: 568, height: '100%' }
				} else if (props.view === 'right') {
					return { width: 650, height: '100%' }
				} else {
					return { width: 1241, height: 855 }
				}
			})

			return {
				brainRef,
				baseClass,
				viewBox,
				viewPortSize,
				currentView,
			}
		},
	})
</script>
<style lang="scss" scoped>
	@media screen and (min-width: 767px) {
		#desktop {
			display: block;
			width: 88vw;
			display: flex;
			justify-content: center;
			img {
				width: 1400px;
				max-width: 100%;
				margin: auto;
			}
		}
		#mobile {
			display: none;
		}
	}

	@media screen and (max-width: 767px) {
		#desktop {
			display: none;
		}
		#mobile {
			display: block;
			img {
				width: 100%;
			}
		}
	}
</style>
